export enum SHOOTINGSTATUS {
	Privado = 1,
	Abierto = 2,
	Grabando = 3,
    Cerrado = 4,
    Cancelado = 5,
    Tentativo = 6
}